module.exports = __webpack_public_path__ + "img/img-tcf@2x.443a44ab.jpg";